import React from 'react';

import Slider from 'react-slick';

const processes = [
  {
    index: 1,
    title: 'Discovery',
    shortened:
      'As an experienced app explainer video company, we know the main key to making stunning video content. Only deep exploration of your values, ideas, and brand story allows us to make magic happen. Due to this combination, we can produce a video that is personalised to your brand and product. ',
    text: 'As an experienced app explainer video company, we know the main key to making stunning video content. Only deep exploration of your values, ideas, and brand story allows us to make magic happen. Due to this combination, we can produce a video that is personalised to your brand and product. ',
  },
  {
    index: 2,
    title: 'Script Writing',
    shortened:
      'After fully understanding your product’s needs, we convert your message into an engaging script. Accompanied by a storyboard, you get a scene-by-scene preview resembling an interactive, presenting the video’s progression and providing engaging content, concentrated on the main benefits.',
    text: 'After fully understanding your product’s needs, we convert your message into an engaging script. Accompanied by a storyboard, you get a scene-by-scene preview resembling an interactive, presenting the video’s progression and providing engaging content, concentrated on the main benefits.',
  },
  {
    index: 3,
    title: 'Voiceover',
    shortened:
      'Our Professional voiceover services add a distinct character to your video as we introduce audio layers. At our app explainer video company, we offer a curated list of professional voice artists aligning with your preferences. Then, you choose the voice that best catches your video’s meaning. A catchy soundtrack and excellent sound effects will keep your audience engaged and interested.',
    text: 'Our Professional voiceover services add a distinct character to your video as we introduce audio layers. At our app explainer video company, we offer a curated list of professional voice artists aligning with your preferences. Then, you choose the voice that best catches your video’s meaning. A catchy soundtrack and excellent sound effects will keep your audience engaged and interested.',
  },
  {
    index: 4,
    title: 'Visualization',
    shortened:
      'After approving the storyboard and choosing the most suitable style for your app explainer video, the process of its visualisation begins. Explainer videos can be visualised in several ways: animation, live-action, or mixed media. As an experienced 3D app animation video company, we can also visualise your ideas with high-quality 3D animation video.',
    text: 'After approving the storyboard and choosing the most suitable style for your app explainer video, the process of its visualisation begins. Explainer videos can be visualised in several ways: animation, live-action, or mixed media. As an experienced 3D app animation video company, we can also visualise your ideas with high-quality 3D animation video.',
  },
  {
    index: 5,
    title: 'Production',
    shortened:
      'After choosing the style and confirming the idea, the enthusiasts of our video production company begin the production process of your video. A video explainer  app will be displayed with your chosen voiceover and visualisation style and suitable music to make your video marketing interactive and memorable.',
    text: 'After choosing the style and confirming the idea, the enthusiasts of our video production company begin the production process of your video. A video explainer  app will be displayed with your chosen voiceover and visualisation style and suitable music to make your video marketing interactive and memorable.',
  },
  {
    index: 6,
    title: 'Final Delivery',
    shortened:
      'After completing the after-production process and professional video editing, we deliver your app explainer video optimised for your preferred platform with no exceptions. You also receive all source materials, providing flexibility for any future adaptations.',
    text: 'After completing the after-production process and professional video editing, we deliver your app explainer video optimised for your preferred platform with no exceptions. You also receive all source materials, providing flexibility for any future adaptations.',
  },
];

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      id="arrow-next"
      className="arrow-next cursor-pointer absolute"
      style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      id="arrow-prev"
      className="arrow-prev hidden cursor-pointer absolute -left-30"
      style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

export default function SimpleSlider() {
  var settings = {
    infinite: false,
    speed: 300,
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
        },
      },
    ],
    afterChange: function (a, b) {
      if (a == 0) {
        if (document.getElementById('arrow-prev')) {
          document.getElementById('arrow-prev').style.display = 'none';
        }
      } else if (a == 3) {
        if (document.getElementById('arrow-next')) {
          document.getElementById('arrow-next').style.display = 'none';
        }
      } else {
        if (document.getElementById('arrow-prev')) {
          document.getElementById('arrow-prev').style.display = 'block';
        }
        if (document.getElementById('arrow-next')) {
          document.getElementById('arrow-next').style.display = 'block';
        }
      }

      var el = document.getElementById('process-row');

      if (el) {
        el.style.width = `${Math.min((a + 1) * (100 / (window.innerWidth > 768 ? 4 : 6)), 100)}%`;
      }
    },
  };

  return (
    <div>
      <div className="relative mb-15">
        <div className="w-full h-2 bg-gray-slider"></div>
        <div
          id="process-row"
          className="absolute left-0 h-4 bg-purple rounded-5 transition-all transition-500"
          style={{ top: '-1px', width: `${100 / 5}%` }}
        ></div>
      </div>

      <Slider {...settings} className="process-slider relative z-10">
        {processes.map((process, index) => (
          <div key={index} className="md:max-w-none mr-15 md:mr-30">
            <div className="relative z-10 pr-15 md:pr-23 h-full md:select-text">
              <div className="relative  sm:bg-auto md:bg-auto py-23  md:p-0 h-full">
                <p className="relative right-0 top-0 text-48 font-black leading-none text-gray-transparent md:text-pink pr-5 md:pr-0">
                  0{process.index}
                </p>

                <p className="text-14 lg:text-16 font-bold md:font-black text-green normal-case md:uppercase mb-23 md:mb-0 max-w-50 md:max-w-none">
                  {process.title}
                </p>

                <p className="text-14 max-w-50 md:max-w-none">
                  <span>{process.text}</span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
